import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1.00392 11.9834C1.00391 11.9898 1.00391 11.9961 1.00391 12.0024C1.00391 14.8689 2.10029 17.4792 3.89657 19.437C5.82001 15.8578 9.06613 13.0952 12.981 11.8031C12.7235 11.2498 12.4508 10.705 12.1636 10.1691C9.00068 11.3529 5.57577 12.0002 1.99968 12.0002C1.66642 12.0002 1.33447 11.9946 1.00392 11.9834Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1.18791 9.98821C1.45752 9.99617 1.72814 10.0002 1.99968 10.0002C5.21128 10.0002 8.29192 9.43945 11.149 8.41055C9.81718 6.26033 8.24152 4.27702 6.46063 2.49921C7.06888 2.14368 7.71433 1.84487 8.38972 1.61004C10.1485 3.44191 11.7069 5.46753 13.0299 7.65168C15.2946 6.63681 17.394 5.31902 19.2765 3.74986C19.7781 4.19226 20.2391 4.67969 20.6531 5.20581C18.6542 6.88664 16.4252 8.30255 14.0201 9.39944C14.3476 10.019 14.6568 10.6498 14.947 11.2911C15.9352 11.1002 16.9558 11.0002 17.9997 11.0002C19.7466 11.0002 21.428 11.2801 23.0017 11.7976C23.003 11.8658 23.0036 11.9341 23.0036 12.0026C23.0036 12.6364 22.95 13.2576 22.8471 13.8621C21.3367 13.3046 19.7037 13.0002 17.9997 13.0002C17.2289 13.0002 16.4727 13.0625 15.7357 13.1823C16.7285 15.7789 17.4166 18.5261 17.7562 21.3803C20.9045 19.4451 23.0036 15.9691 23.0036 12.0026C23.0036 5.92749 18.079 1.00244 12.0039 1.00244C9.98244 1.00244 8.08833 1.54772 6.46063 2.49921C3.75058 4.08341 1.77906 6.79369 1.18791 9.98821Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.8454 22.313C15.5506 19.2843 14.8401 16.3773 13.7716 13.65C10.1128 14.8076 7.10426 17.4278 5.43202 20.8243C7.26563 22.1925 9.54018 23.0024 12.0039 23.0024C13.3552 23.0024 14.6495 22.7588 15.8454 22.313Z"}}]};

const LogoDribbbleFilled = Vue.extend<IconProps>({
  name: 'LogoDribbbleFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'logo-dribbble-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LogoDribbbleFilled;
